import { get, post, put } from '../utils/request'

/**
 * 微信小程序授权登录
 * @param {Object} data 登录参数
 * @returns {Promise}
 */
export function wxLogin(data) {
  return post('/User/wx-login', data)
}

/**
 * 用户登录
 * @param {Object} params 登录参数
 * @returns {Promise}
 */
export function login(params) {
  return post('/User/login', null, { params })
}

/**
 * 获取用户信息
 * @param {number} userId 用户ID
 * @returns {Promise}
 */
export function getUserInfo(userId) {
  return get(`/User/${userId}`)
}

/**
 * 更新用户信息
 * @param {Object} data 用户信息对象
 * @returns {Promise}
 */
export function updateUserInfo(data) {
  return put('/User', data)
}

/**
 * 获取用户剩余使用次数
 * @param {number} userId 用户ID
 * @returns {Promise}
 */
export function getRemainingCount(userId) {
  return get(`/User/${userId}/remaining-count`)
}

/**
 * 增加用户剩余使用次数
 * @param {number} userId 用户ID
 * @param {number} count 增加的次数
 * @returns {Promise}
 */
export function increaseCount(userId, count) {
  return post(`/User/${userId}/increase-count?count=${count}`)
}

/**
 * 更新用户头像和昵称
 * @param {number} userId 用户ID
 * @param {FormData} formData 包含头像文件和昵称的表单数据
 * @returns {Promise}
 */
export function updateProfile(userId, formData) {
  return post(`/User/${userId}/update-profile`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 获取用户列表（管理后台使用）
 * @param {number} pageIndex 页码
 * @param {number} pageSize 每页大小
 * @param {string} searchKey 搜索关键字
 * @returns {Promise}
 */
export function getUserList(pageIndex = 1, pageSize = 10, searchKey = '') {
  let url = `/User?pageIndex=${pageIndex}&pageSize=${pageSize}`
  if (searchKey) {
    url += `&searchKey=${encodeURIComponent(searchKey)}`
  }
  return get(url)
}

/**
 * 获取微信小程序配置（仅用于调试）
 * @returns {Promise}
 */
export function getWxConfig() {
  return get('/User/wx-config')
} 